import React from 'react';
import { Flex, Text, Button } from '@chakra-ui/react';

const ScheduleAMeetingSection = () => (
  <Flex alignItems="center" direction="column" my="14">
    <Text textAlign="center" fontSize="lg">
      Interested in learning more about our products?
    </Text>
    <Button
      size="lg"
      mt="10"
      width="fit-content"
      fontSize="sm"
      fontWeight="extrabold"
    >
      Schedule a Meeting
    </Button>
  </Flex>
);

export default ScheduleAMeetingSection;
